import { _ } from "~/i18n";
import { node } from "~/util/dom";
import Tooltip from "~/ui/tooltip";

interface IHeaderOptions {
	compact: boolean;
	title: string | HTMLElement | DocumentFragment;
	avatar: string;
	className: string;
	premium: HTMLMapyAvatarElement["premium"];
	fanda: boolean;
}

export default class Header {
	_compact: boolean;

	_container: HTMLDivElement;

	_poster: HTMLDivElement;

	_titleContainer: HTMLDivElement;

	_title: HTMLDivElement;

	_toolbar: HTMLDivElement;

	_leftButtons: HTMLDivElement;

	_rightButtons: HTMLDivElement;

	_avatar: HTMLImageElement;

	_avatarElement: HTMLMapyAvatarElement;

	_fanda: HTMLDivElement;

	_tooltip: Tooltip;

	constructor({
		compact = false,
		title = "",
		avatar,
		premium = "none",
		fanda = false,
		className = "",
	}: Partial<IHeaderOptions>) {
		this._container = node("div", { className: `ui-header ${className}` });
		this._poster = node("img", { src: "/img/header-placeholder.svg", className: "ui-header__poster" });
		this._avatar = node("img", avatar ? { src: avatar } : {});
		this._avatarElement = node("mapy-avatar", { premium: Mapy.CUS.user.premiumCrowns ? premium : "none", className: "ui-header__avatar", size: 64 });
		this._fanda = node("div", { className: `ui-header__fanda ${Mapy.CUS.user.premiumCrowns && fanda ? "ui-header__fanda--visible" : ""}` }, _("userProfile.fan"));
		this._tooltip = new Tooltip({
			anchor: this._fanda,
			trigger: this._fanda,
			content: node("p", {}, _("userProfile.fanTooltip")),
			className: "ui-header__tooltip",
		});

		this._avatarElement.appendChild(this._avatar);
		this._titleContainer = node("div", { className: "ui-header__title-container" });
		this._title = node("div", { className: "ui-header__title" });
		this._toolbar = node("div", { className: "ui-header__toolbar" });
		this._leftButtons = node("div", { className: "ui-header__left-buttons" });
		this._rightButtons = node("div", { className: "ui-header__right-buttons" });
		this._container.append(this._poster, this._avatarElement, this._toolbar, this._title, this._fanda);
		this._toolbar.append(this._leftButtons, this._titleContainer, this._rightButtons);
		this.compact = compact;
		this.title = title;
	}

	destroy() {
		this._tooltip.destroy();
	}

	set compact(compact: boolean) {
		this._compact = compact;
		this._container.classList.toggle("ui-header--compact", compact);

		if (compact) {
			const contRect = this._titleContainer.getBoundingClientRect();
			const toolbarRect = this._toolbar.getBoundingClientRect();

			this._title.style.setProperty("left", `${contRect.left - toolbarRect.left}px`);
			this._title.style.setProperty("right", `${toolbarRect.right - contRect.right}px`);
		} else {
			this._title.style.removeProperty("left");
			this._title.style.removeProperty("right");
		}
	}

	set title(title: string | HTMLElement | DocumentFragment) {
		if (typeof title === "string") {
			this._title.textContent = title;
			this._title.classList.add("ui-header__title--text");
		} else {
			this._title.innerHTML = "";
			this._title.appendChild(title);
			this._title.classList.remove("ui-header__title--text");
		}
	}

	set avatar(avatar: string) {
		this._avatar.src = avatar || "";
	}

	set premium(premium: HTMLMapyAvatarElement["premium"]) {
		this._avatarElement.premium = Mapy.CUS.user.premiumCrowns ? premium : "none";
	}

	set fanda(fanda: boolean) {
		this._fanda.classList[Mapy.CUS.user.premiumCrowns && fanda ? "add" : "remove"]("ui-header__fanda--visible");
	}

	get node() {
		return this._container;
	}

	get leftButtons() {
		return this._leftButtons;
	}

	get rightButtons() {
		return this._rightButtons;
	}
}
